module.exports = __webpack_public_path__ + "Marker.f1a69c7deddb96da59f29a9e02978514.png";